<template>
  <ReviewDelete :review="review" @success="closeAndRedirect" />
</template>

<script setup>
import ReviewDelete from '@/components/ReviewDelete'
import { useRouter, useRoute } from 'vue-router'

const props = defineProps({
  review: Object
})

const emit = defineEmits(['close'])
const router = useRouter()
const route = useRoute()

const closeAndRedirect = () => {
  emit('close')
  // If we are on the review page, redirect to the user's reviews list
  if (route.name === 'WebReviewsSingle') {
    router.push({ name: 'WebIndex' })
    return
  }
}
</script>
